import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import React, { useContext, useEffect, useState } from "react";
import MDSelectBox from "components/MDSelectBox";
import { useFormik } from "formik";
import { initialValues } from "./Schemas/initialValue";
import { validationSchema } from "./Schemas/validation";
import { ModalContext } from "context/ModalContext";
import PropTypes from "prop-types";
import { LoginFormContext } from "context/LoginFormContext";
import { bannerAdd } from "Apis/banner";
import { updateBanner } from "Apis/banner";
import ImageUploader from "components/MDImageUploader";
import { BannerContext } from "context/BannerContext";
import SubmitButton from "components/SubmitButton";
import { statusData } from "helpers/constant";

const BannerForm = ({ getBannerList }) => {
  const { editData, pageList, allPagesList, getEventApi, eventListData } =
    useContext(BannerContext);
  const { setNotification, profileImage, setProfileImage } = useContext(LoginFormContext);
  const [page, setPage] = useState("Home Page");
  const { setOpen, formIsEdit } = useContext(ModalContext);
  const [status, setStatus] = useState({
    label: "Inactive",
    value: "0",
  });
  const [event, setEvent] = useState([]);

  //setData in Formik...
  const setDataInFormik = async () => {
    formik.setValues(editData);
    setPage({
      label: editData?.type?.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase()),
    });
    formik.setFieldValue("banner_image", editData?.banner_images[0]?.image.split("/").pop());
    setProfileImage({
      url: editData?.banner_images[0]?.image || null,
      name: null,
    });
  };

  const getStatusLabel = (id) => {
    const status = statusData.find((item) => item.value == id);
    return status ? status.label : "-";
  };

  const getEventLabel = (id) => {
    const eventList = eventListData.find((item) => item.id === id);
    return eventList ? eventList.label : "-";
  };

  useEffect(() => {
    getEventApi();
    allPagesList();
    if (formIsEdit) {
      setDataInFormik();
      setEvent(
        editData.event_id
          ? { label: getEventLabel(editData.event_id), value: editData.event_id }
          : null
      );
      setStatus({ label: getStatusLabel(editData?.is_active), value: editData?.is_active });
    } else if (formIsEdit === false) {
      setProfileImage({
        url: null,
        name: null,
      });
    }
  }, []);

  //HandleSubmit Form
  const handleSubmit = async (values) => {
    if (!formIsEdit) {
      let response = await bannerAdd(values);
      if (response?.status === 200) {
        getBannerList();
        setOpen(false);
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: response?.data?.message,
          open: true,
        });
      }
    } else {
      let response = await updateBanner(values);
      if (response?.status === 200) {
        getBannerList();
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: response?.data?.message,
          open: true,
        });
        setOpen(false);
      } else {
        setNotification({
          color: "error",
          icon: "cancel",
          title: "Error",
          content: response?.data?.message,
          open: true,
        });
      }
    }
  };

  const handleStatusChange = (value) => {
    if (value) {
      formik.setFieldValue("is_active", value.value);
      setStatus(value);
    } else {
      formik.setFieldValue("is_active", null);
      setStatus(null);
    }
  };

  const handleSelectPage = async (data) => {
    formik.setFieldValue("type", data?.value);
    setPage(data?.label);
  };

  //Formik
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: handleSubmit,
  });

  const handleEventValue = (value) => {
    if (value) {
      formik.setFieldValue("event_id", value.id);
      setEvent(value);
    } else {
      formik.setFieldValue("event_id", null);
      setEvent(null);
    }
  };

  return (
    <>
      <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
        <Grid container spacing={2} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          {/* Image */}
          <Grid item xs={12} md={12} sx={{ paddingTop: "20px !important" }}>
            <ImageUploader
              img={profileImage?.url}
              folderName={"/banners"}
              name={"banner_image"}
              fileName={"banner_image"}
              formik={formik}
              label="Banner Image"
              sx={{
                width: "100px",
                height: "100px",
                objectFit: "cover",
                borderRadius: "50%",
                marginBottom: "16px",
              }}
              required
            />
            {formik.touched.banner_image && formik.errors.banner_image && (
              <MDBox
                sx={{
                  fontSize: "12px",
                  color: "red",
                  marginLeft: "5px",
                }}
              >
                {formik.errors.banner_image}
              </MDBox>
            )}
          </Grid>

          {/* Type */}
          <Grid item xs={12} md={6} sx={{ paddingTop: "30px !important" }}>
            <MDSelectBox
              name="type"
              defaultValue={page}
              options={pageList}
              handleChange={(value) => handleSelectPage(value)}
              label="Page (જ્યાં તમે બેનર દેખાડવા માંગો છો તે પેજ પસંદ કરો)"
              width="100%"
              isImage={false}
              multiple={false}
              onBlur={formik.handleBlur}
            />
            {formik.touched.type && formik.errors.type && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.type}
              </MDBox>
            )}
          </Grid>

          <Grid item xs={12} md={6} sx={{ paddingTop: "30px !important" }}>
            <MDInput
              type="text"
              name="link"
              label="link"
              variant="standard"
              value={formik.values.link}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              fullWidth
            />
          </Grid>
          {/* Event */}
          <Grid item xs={12} md={formIsEdit ? 12 : 6} sx={{ paddingTop: "30px !important" }}>
            <MDSelectBox
              name="event_id"
              defaultValue={event}
              options={eventListData}
              handleChange={(value) => handleEventValue(value)}
              label="Event"
              width="100%"
              multiple={false}
              onBlur={formik.handleBlur}
            />
            {formik.touched.event_id && formik.errors.event_id && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.event_id}
              </MDBox>
            )}
          </Grid>

          {formIsEdit && (
            <Grid item xs={12} md={6} sx={{ paddingTop: "30px !important" }}>
              <MDInput
                type="number"
                name="display_order"
                label="Display Order"
                variant="standard"
                value={formik.values.display_order}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                fullWidth
              />
            </Grid>
          )}
          {/* status */}
          <Grid item xs={12} md={formIsEdit ? 6 : 6} sx={{ paddingTop: "30px !important" }}>
            <MDSelectBox
              name="is_active"
              defaultValue={status}
              options={statusData}
              handleChange={(value) => handleStatusChange(value)}
              label="Status"
              width="100%"
              multiple={false}
              onBlur={formik.handleBlur}
              required
            />
            {formik.touched.is_active && formik.errors.is_active && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.is_active}
              </MDBox>
            )}
          </Grid>
        </Grid>

        <MDBox sx={{ width: "100%", textAlign: "center", marginTop: "40px" }}>
          <SubmitButton btnText={formIsEdit ? "Update" : "Add"} type="submit" />
        </MDBox>
      </MDBox>
    </>
  );
};
BannerForm.propTypes = {
  getBannerList: PropTypes.func,
};
export default BannerForm;
